import useAnalytics from '@sdk/analytics/useAnalytics';
import { AnalyticsEvents } from '@sdk/analytics/types';
import getNowDate from '@sdk/utils/getNowDate';
import useConfig from '@sdk/config/useConfig';
import useModalState from '@sdk/components/ui/modal/useModalState';

import { useNavigation } from '@web/navigation/NavigationProvider';

const ONE_MINUTE = 1000 * 60;

export const useICalAnnouncement = (currentUser, saveClientFlags) => {
  const { track } = useAnalytics();
  const { isVisible, open, close } = useModalState();
  const { navigate } = useNavigation();
  const {
    FEATURE_FLAGS: { ICAL_RELEASE_DATE },
  } = useConfig();

  const shouldBeShown =
    currentUser &&
    ICAL_RELEASE_DATE &&
    new Date(currentUser.org.createdAt) < ICAL_RELEASE_DATE &&
    !currentUser.settings.clientFlags.iCalAnnouncementShown;

  if (shouldBeShown && !isVisible) {
    setTimeout(open, ONE_MINUTE);
  }

  const dismiss = () => {
    saveClientFlags({ iCalAnnouncementShown: getNowDate().toISOString() });
    close();
  };

  const onButtonClick = () => {
    close();
    navigate('shifts', { openIcalTooltip: true }, { reload: true });
    track(AnalyticsEvents.iCalAnnouncementTryNowClicked);
    saveClientFlags({ iCalAnnouncementShown: getNowDate().toISOString() });
  };

  return {
    shouldBeShown,
    onButtonClick,
    dismiss,
    isVisible,
    close,
  };
};
